import { createContext } from 'react';

import { TimeseriesChartXAxisProps } from '../slots/XAxis.js';

type XAxisPropsRequired =
  | Required<Pick<TimeseriesChartXAxisProps, 'max' | 'min'>>
  | Record<string, never>;

export const TimeseriesMinMaxXAxisContext = createContext<XAxisPropsRequired>(
  {},
);

TimeseriesMinMaxXAxisContext['displayName'] = 'TimeseriesMinMaxXAxisContext';
